import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { TpDashboardContext, TpDashboardElement } from '../interfaces';
import { elemTypeMap } from './elementTypes';
import { performMoveElement, performRemoveElement, promptAddElement } from './generalTools';

import styles from '../../layouters/Layouters.module.scss';
import { getUserError } from '../../../../components/miscUtils';

function getEditBox(editBoxType: string, children: any) {
  if (editBoxType == 'vertical-right')
    return (
      <div className={styles.editToolBoxVertical}>
        <div className={styles.editToolBoxVerticalButtonBox}>{children}</div>
      </div>
    );

  if (editBoxType == 'right-box') return <div className={styles.editToolWidget}>{children}</div>;

  if (editBoxType == 'horizontal-bottom') return <div className={styles.editToolBoxHorizontal}>{children}</div>;

  throw getUserError(`Invalid edit box type ${editBoxType}`);
}

interface TpElementEditToolsProps {
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  parentElemDef: TpDashboardElement | null;
  elemDef: TpDashboardElement;
  dispatch: AppDispatch;
}

export function ElementEditTools({
  dataContext,
  dashboardContext,
  parentElemDef,
  elemDef,
  dispatch,
}: TpElementEditToolsProps) {
  const elemTypeDef = elemTypeMap[elemDef.elemType];
  if (!elemTypeDef) throw getUserError(`Invalid element type ${elemDef.elemType}`);

  let parentElemTypeDef = null;
  if (parentElemDef) {
    parentElemTypeDef = elemTypeMap[parentElemDef.elemType];
    if (!parentElemTypeDef) throw getUserError(`Invalid element type ${parentElemDef.elemType}`);
  }

  const movableInParent = parentElemTypeDef && parentElemTypeDef.compatibleChildren.length > 0;
  let isFirstInParent;
  let isLastInPaent;
  if (movableInParent) {
    const parentElements = (parentElemDef! as any).elements!;
    const indexInparentElements = parentElements.map((el: any) => el.id).indexOf(elemDef.id);
    isFirstInParent = indexInparentElements == 0;
    isLastInPaent = indexInparentElements == parentElements.length - 1;
  }

  let addButton = null;
  if (elemTypeDef.compatibleChildren.length > 0)
    addButton = (
      <button onClick={() => promptAddElement(dataContext, dashboardContext, elemDef.elemType, elemDef.id, dispatch)}>
        <FontAwesomeIcon icon={['fas', 'plus']} />
      </button>
    );

  const buttons = (
    <>
      {!elemTypeDef.addBoxType && addButton}

      {elemTypeDef.promptConfigure && (
        <button onClick={() => elemTypeDef.promptConfigure(dataContext, dashboardContext, elemDef, dispatch)}>
          <FontAwesomeIcon icon={['fas', 'gear']} />
        </button>
      )}

      <button onClick={() => performRemoveElement(dataContext, dashboardContext, elemDef.id, dispatch)}>
        <FontAwesomeIcon icon={['fas', 'trash-can']} />
      </button>

      {movableInParent && (
        <>
          {!isFirstInParent && (
            <button onClick={() => performMoveElement(dataContext, dashboardContext, elemDef.id, -1, dispatch)}>
              {parentElemTypeDef?.childrenLayout == 'horizontal' ? (
                <FontAwesomeIcon icon={['fas', 'arrow-left']} />
              ) : (
                <FontAwesomeIcon icon={['fas', 'arrow-up']} />
              )}
            </button>
          )}
          {!isLastInPaent && (
            <button onClick={() => performMoveElement(dataContext, dashboardContext, elemDef.id, +1, dispatch)}>
              {parentElemTypeDef?.childrenLayout == 'horizontal' ? (
                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
              ) : (
                <FontAwesomeIcon icon={['fas', 'arrow-down']} />
              )}
            </button>
          )}
        </>
      )}
    </>
  );

  const box1 = getEditBox(elemTypeDef.editBoxType, buttons);

  let box2 = null;
  if (addButton && elemTypeDef.addBoxType) box2 = getEditBox(elemTypeDef.addBoxType, addButton);

  return (
    <>
      {box1}
      {box2}
    </>
  );
}
